import * as tslib_1 from "tslib";
import * as typings from '../../../../../../form/schema';
import { TextInputControl } from '../../../../../../form/src/common/controls/input-controls/text-input-control';
import { Component } from 'vue-property-decorator';
import { Tooltip } from "@h3/antd-vue";
let InputTextarea = class InputTextarea extends TextInputControl {
    constructor() {
        super(...arguments);
        // @Prop({
        // 	default: TextAreaType.LongText
        // })
        // type! :TextAreaType
        this.renderComponent = true;
    }
    forceRerender() {
        // 从 DOM 中删除 组件
        this.renderComponent = false;
        let chArr = document.body.getElementsByClassName('ke-container');
        for (let i = 0; i < chArr.length; i++) {
            if (chArr[i] !== null)
                chArr[i].parentNode.removeChild(chArr[i]);
        }
        this.$nextTick(() => {
            // 在 DOM 中添加 组件
            this.renderComponent = true;
        });
    }
    get isCrossEntityText() {
        if (this.val) {
            try {
                const parsedArr = JSON.parse(this.val);
                return parsedArr instanceof Array && parsedArr && parsedArr.length
                    && parsedArr[0].hasOwnProperty('id') && parsedArr[0].hasOwnProperty('name') && parsedArr[0].hasOwnProperty('type');
            }
            catch (e) {
                return false;
            }
        }
        return false;
    }
    get crossEntityStaff() {
        if (this.isCrossEntityText) {
            try {
                const parsedArr = JSON.parse(this.val);
                return parsedArr;
            }
            catch (e) {
                return [];
            }
        }
        return [];
    }
    mounted() {
        typings.EventBus.$on('activeKey', ({ data: any }) => {
            this.forceRerender();
        });
    }
    onChange() {
        const val = this.val.length === 0 ? null : this.val;
        this.setValue(val);
    }
};
InputTextarea = tslib_1.__decorate([
    Component({
        name: 'input-textarea',
        components: {
            ATooltip: Tooltip,
            H3Textarea: () => import('../h3-textarea.vue'),
            H3Editor: () => import(/* webpackChunkName: "h3-editor" */ './h3-editor.vue'),
        },
    })
], InputTextarea);
export default InputTextarea;
